import { render, staticRenderFns } from "./RegexItem.vue?vue&type=template&id=4551a8c0&scoped=true&"
import script from "./RegexItem.vue?vue&type=script&lang=js&"
export * from "./RegexItem.vue?vue&type=script&lang=js&"
import style0 from "./RegexItem.vue?vue&type=style&index=0&id=4551a8c0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4551a8c0",
  null
  
)

export default component.exports